/*
 * Copyright (C) 2021. Def Studio
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Authors: Fabio Ivona <fabio.ivona@defstudio.it> & Daniele Romeo <danieleromeo@defstudio.it>
 */

require('./template-attachment');
require('./zoomables');
require('./input-number-format');
require('./confirmable-button');
require('./deselectable-radio');
